import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../../components/CustomComponents/CustomViewPage'
import UploadHeaderDialog from '../../../components/Dialog/UploadHeadersDialog'
import { useUploadHeader } from '../../../hooks/CompanyConfiguration/useUploadHeader'

export default function ViewUploadHeader() {
  const { getUploadHeader, uploadHeader, loading } = useUploadHeader()
  const params = useParams()
  const [headers, setHeaders] = useState(false)

  const [data, setData] = useState([])

  useEffect(() => {
    getUploadHeader({ _id: params.uploadHeaderId })
  }, [params.uploadHeaderId])

  useEffect(() => {
    if (uploadHeader) {
      setData([
        { label: 'Upload Header Code', data: uploadHeader.uploadHeaderCode },
        { label: 'Name', data: uploadHeader.name },
        { label: 'Headers', data: 'View Headers', style: { cursor: 'pointer', color: 'blue', textDecoration: 'underline' }, onClick: () => setHeaders(uploadHeader.headers) },
        // { label: 'Date of Birth', data: formatDat(uploadHeader.dob) },
      ])
    }
  }, [uploadHeader])
  return (
    <>
      {' '}
      <CustomViewPage loading={loading} heading="Upload Header" editUrl="upload-header" id={params.uploadHeaderId} redirect="ALL_UPLOAD_HEADERS" data={data} />
      <UploadHeaderDialog open={headers} handleClose={() => setHeaders(false)} data={headers} />
    </>
  )
}
